<script setup lang="ts">
import { PhFlask, PhGear, PhPlus, PhSignOut } from "@phosphor-icons/vue";
import { computed } from "vue";
import { RouterLink } from "vue-router";

import logoUrl from "@/assets/kurioseando-logo.png";
import { useAuthStore } from "@/stores/auth";
import { useConnectionsStore } from "@/stores/connections";

const auth = useAuthStore();
const connections = useConnectionsStore();
const who = computed(() => (auth.user ? `${auth.user.email} · ${auth.user.tenantId}` : ""));
</script>

<template>
  <header class="app-header">
    <nav class="app-nav" aria-label="Principal">
      <RouterLink to="/" class="brand" title="Biblioteca">
        <img :src="logoUrl" alt="Kurioseando · Biblioteca" width="110" height="40" />
      </RouterLink>
      <RouterLink to="/upload" class="btn btn-primary upload-link">
        <PhPlus :size="18" aria-hidden="true" />Subir
      </RouterLink>
      <RouterLink
        v-if="auth.isAdmin"
        to="/admin/prompts"
        class="btn btn-secondary btn-icon"
        title="Administración: prompts y laboratorio"
        aria-label="Administración"
        data-testid="admin-link"
      >
        <PhFlask :size="18" aria-hidden="true" />
      </RouterLink>
      <RouterLink
        to="/settings"
        class="btn btn-secondary btn-icon settings-link"
        title="Ajustes"
        aria-label="Ajustes"
        data-testid="settings-link"
      >
        <PhGear :size="18" aria-hidden="true" />
        <span v-if="connections.needsAttention" class="dot" aria-hidden="true" />
      </RouterLink>
      <button
        type="button"
        class="btn btn-secondary btn-icon"
        :title="`Cerrar sesión (${who})`"
        aria-label="Cerrar sesión"
        @click="auth.signOut()"
      >
        <PhSignOut :size="18" aria-hidden="true" />
      </button>
    </nav>
  </header>
</template>

<style scoped>
.app-header {
  padding-top: var(--safe-top);
}
.app-nav {
  max-width: var(--page-max);
  margin: 0 auto;
  display: flex;
  align-items: center;
  gap: 10px 12px;
  padding: var(--space-3) calc(var(--page-gutter) + var(--safe-right)) var(--space-3)
    calc(var(--page-gutter) + var(--safe-left));
}
.brand {
  margin-right: auto;
  display: flex;
  align-items: center;
  border-radius: var(--radius-md);
}
.brand img {
  height: 40px;
  width: auto;
  mix-blend-mode: multiply;
  margin-left: -4px;
}
.upload-link {
  min-height: 40px;
}
.app-nav .btn-icon {
  width: 40px;
  height: 40px;
}
.settings-link {
  position: relative;
}
.dot {
  position: absolute;
  top: 6px;
  right: 6px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--color-accent-2);
}
</style>
